import * as React from 'react';
import styled from 'styled-components';

import { TableOfContent } from '../Layout/Landing/Content/TableOfContent/TableOfContent';
import { TableOfContentProps } from '../Layout/Landing/Content/TableOfContent/TableOfContentType';

const Main = styled.div.withConfig({
  componentId: 'BlogTableOfContent_Main',
} as any)`
  margin-top: 32px;

  #blog-table-of-content {
    width: 214px;
    min-width: 214px;
    max-width: 214px;
  }
`;

export const BlogTableOfContent = (props: TableOfContentProps) => (
  <Main className="blog-table-of-content">
    <TableOfContent
      stickyMode="ALWAYS_SHOW"
      stickOnElmPosition={{
        align: 'right',
        gapInPx: 32,
      }}
      {...props}
    />
  </Main>
);
